'use strict';
import {module} from '../app';

module.controller('DiagramCtrl', [
  '$scope', 'diagramViewModel', '$location', function ($scope, DiagramViewModel, $location) {
    let ssn = $location.search().ssn;
    let sdate = $location.search().sdate;
    let vm = new DiagramViewModel();
    $scope.vm = vm;
    vm.init(ssn, sdate);

    $scope.$watch('vm.selectedElement', () => {
      if (vm.selectedElement) {
        vm.commentText = vm.selectedElement.Comments;
      } else {
        vm.commentText = '';
      }
    });

    $scope.$watchCollection('vm.problemsList', () => {
      let l = vm.problemsList;

      if (l) {
        let index = 1;
        l.forEach((item) => {
          item.index = index;
          index++;
        });
      }
    });
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/diagram.js